import * as React from 'react';
import classNames from 'classnames';
import { Layout } from '../Layout';
import * as styles from './TopControls.css';

export interface ITopControlsLayoutProps {
  gallery: React.ReactNode;
  favorite: React.ReactNode;
}

export function TopControls({ gallery, favorite }: ITopControlsLayoutProps) {
  return (
    <div className={styles['container']}>
      <Layout>
        <div className={styles['inner_container']}>
          <div className={classNames(styles['item'], styles['item--favorite'])}>{favorite}</div>
          <div className={styles['item']}>{gallery}</div>
        </div>
      </Layout>
    </div>
  );
}
